export class RuntimeError extends Error {
    code: 'runtimeError';

    constructor(error) {
        super(error);

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RuntimeError);
        }

        this.code = 'runtimeError';

        this.message = this.code + ' - ' + (error.message ? ' - ' + error.message : '');
    }
}
